import React from 'react';
import { Alert, AlertColor, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface AppAlertProps {
  severity: AlertColor;
  message: string;
  onClose?: () => void;
  sx?: object;
}

const AppAlert: React.FC<AppAlertProps> = ({ severity, message, onClose, sx }) => (
  <Alert
    severity={severity}
    action={
      onClose ? (
        <IconButton
          aria-label="close"
          color="inherit"
          size="small"
          onClick={onClose}
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>
      ) : null
    }
    sx={{ mb: 2, ...sx }}
    variant="outlined"
  >
    {message}
  </Alert>
);

export default AppAlert; 